<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      @pesquisar="pesquisar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
            <CampoGenerico
              id="nome"
              label="Tabela"
              :valor="filtro.nome"
              @atualizar="filtro.nome = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela
        ><TabelasProcedimentoTabela :tabelas="tabelas"
      /></template>
      <template #fichas>
        <div
          v-for="t in tabelas"
          :key="t._id"
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4"
        >
          <TabelasProcedimentoFicha :tabela="t" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import TabelaServico from '@/servicos/TabelaServico'

import TabelasProcedimentoFicha from './TabelasProcedimentoFicha'
import TabelasProcedimentoTabela from './TabelasProcedimentoTabela'

export default {
  components: {
    TabelasProcedimentoFicha,
    TabelasProcedimentoTabela,
    BlocoFiltroPesquisa,
    CampoGenerico,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const tabelas = ref([])
    const servico = new TabelaServico()
    const nomeResultado = 'tabelas'
    const nomeDoForm = 'TabelaProcedimentoForm'
    const filtro = ref({
      tabela: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: tabelas,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(30)
    return { tabelas, filtro, ...pesquisa }
  },
}
</script>
